import { render, staticRenderFns } from "./SegmentsChildrens.vue?vue&type=template&id=19de8b52"
import script from "./SegmentsChildrens.vue?vue&type=script&lang=js"
export * from "./SegmentsChildrens.vue?vue&type=script&lang=js"
import style0 from "./SegmentsChildrens.vue?vue&type=style&index=0&id=19de8b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports